
function resolveLocaleMapping(locale, localeMap, defaultLocale) {
  const lwCaseLocale = locale
    .trim()
    .replace('_', '-')
    .replace(/'/g, '')
    .replace(/"/g, '')
    .toLowerCase();

  const lang = (lwCaseLocale.split('-').length > 1)
    ? lwCaseLocale.split('-')[0] : lwCaseLocale;

  let foundLocale = null;
  let foundLang = null;
  let foundLocaleValue = null;

  Object.entries(localeMap).forEach(([key, value]) => {
    const lwCaseKey = key.toLowerCase();
    if (lwCaseKey === lwCaseLocale) {
      foundLocale = value;
    }
    if (lwCaseKey === lang) {
      foundLang = value;
    }
    if (value.toLowerCase() === lwCaseLocale) {
      foundLocaleValue = value;
    }
  });

  if (foundLocale !== null) {
    return { locale: foundLocale, mapped: true };
  }
  if (foundLocaleValue !== null) {
    return { locale: foundLocaleValue, mapped: true };
  }
  if (foundLang !== null) {
    return { locale: foundLang, mapped: true };
  }

  return { locale: defaultLocale, mapped: false };
}

/**
 * The search of exists mapped locale
 *
 * @param locales - 'en' or 'en-US' or 'en_US' or '*' or 'en,da,zh-TW, fr_FR,*'
 * @param localeMap - {'en': 'en-US', 'zh': 'zh-CN', 'zh-SG': 'zh-CN'}
 * @param defaultLocale - 'en-US'
 * @returns - mapped or default locale
 */
export function resolveLocale(locales, localeMap, defaultLocale) {
  if (typeof locales !== 'undefined' && locales !== null
    && locales.length < 255 && /^[-_a-zA-Z,'" *]+$/.test(locales)) {
    if (!locales.includes(',')) {
      return resolveLocaleMapping(locales, localeMap, defaultLocale).locale;
    }

    let firstMappedLocale = null;

    locales.split(',').forEach((localeItem) => {
      if (firstMappedLocale == null) {
        const resolvedLocale = resolveLocaleMapping(localeItem, localeMap, defaultLocale);
        if (resolvedLocale.mapped) {
          firstMappedLocale = resolvedLocale.locale;
        }
      }
    });

    if (firstMappedLocale != null) {
      return firstMappedLocale;
    }
  }

  return defaultLocale;
}
